import { Divider, AbsoluteCenter, Box, Text } from '@chakra-ui/react'
import React from 'react'

export default function StepsHeader({heading, mt}: any): JSX.Element{
  return (
    <Box position="relative" padding="10" bg="gray.50" mb={1} mt={mt}>
                <Divider borderColor="gray.100" border="1px solid" />
                <AbsoluteCenter bg="gray.50" px="4">
                  <Text fontSize="xl" fontWeight="500">
                    {heading}
                  </Text>
                </AbsoluteCenter>
              </Box>
  )
}

